import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { company_name, facebook_page_url, instagram_page_url } from "../../constants/constants";
import Sidebar from "../sidebar/Sidebar";
import ProductFilter from "../productFilter/ProductFilter";
import MyCart from "../myCart/MyCart";
function Footer() {
  const current_year = moment().format("YYYY");
  return (
    <>
      <footer className="pt-9 pb-10 footer bg-color-2">
        <div className="container container-xxl">
          <div className="row">
            <div className="col-lg mb-6 mb-lg-0">
              <Link to="/" className="footer-logo d-block">
                <img src="/luminit-logo-1.png" alt={company_name} />
              </Link>
            </div>
            <div className="col-sm-6 col-lg mb-6 mb-lg-0">
              <ul className="list-unstyled mb-0">
                <li className="py-0">
                  <Link to="/contact" className="lh-225 font-weight-500">
                    Impressum
                  </Link>
                </li>
                <li className="py-0">
                  <Link to="/privacy-policy" className="lh-225 font-weight-500">
                    Datenschutz
                  </Link>
                </li>
                <li className="py-0">
                  <Link to="/term-and-conditions" className="lh-225 font-weight-500">
                    AGB
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-sm-6 col-lg">
              <ul className="list-inline text-lg-right mb-2">
                <li className="list-inline-item mr-4">
                  <a href={facebook_page_url} target="_blank" rel="noreferrer" className="fs-20">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="list-inline-item mr-4">
                  <a href={instagram_page_url} target="_blank" rel="noreferrer" className="fs-20">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
              <p className="mb-0 text-gray text-lg-right font-weight-500">
                © {current_year} {company_name}.
                <br />
                Alle Rechte vorbehalten.
              </p>
            </div>
          </div>
        </div>
      </footer>
      <Sidebar />
      <MyCart />
      <ProductFilter />
    </>
  );
}
export default Footer;
